import { produce } from "immer";
import {
  CHECK,
  CHECK_FAILURE,
  CHECK_SUCCESS,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  GOOGLE_INITIALIZED,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAILURE,
  LOGOUT_SUCCESS,
  REGISTER_SAGA,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_SUCCESS,
  SENT_RESET_PASSWORD_FAILURE,
  SENT_RESET_PASSWORD_PENDING,
  SENT_RESET_PASSWORD_SUCCESS,
  GET_USERDATA,
  GET_USERDATA_SUCCESS,
  GET_USERDATA_FAILURE,
  GET_SUBLIST,
  GET_SUBLIST_SUCCESS,
  GET_SUBLIST_FAILURE,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  TOGGLE_MENU,
  UPDATE_ALL_FEED_ACCESS,
  CHECK_EMAIL_SUB,
  CHECK_EMAIL_SUB_SUCCESS,
  CHECK_EMAIL_SUB_FAILURE,
  UPDATE_EMAIL_SUB,
  UPDATE_EMAIL_SUB_SUCCESS,
  UPDATE_EMAIL_SUB_FAILURE,
  GET_APP_QR,
  GET_APP_QR_SUCCESS,
  GET_APP_QR_FAILURE,
  GET_MENU_INDICATORS,
  GET_MENU_INDICATORS_SUCCESS,
  GET_MENU_INDICATORS_FAILURE,
  TOKEN_REFRESHED,
} from "./constants";

const initialMenuIndicators = {
  leave: {
    leave_request: 0,
    pending_my_approval: 0,
    total_count: 0,
  },
  maintenance: {
    expiring_certificates_count: 0,
    pending_approval_inspections_count: 0,
    overdue_schedules_count: 0,
    today_schedules_count: 0,
    pending_approval_requests_count: 0,
  },
};

export const initialState = {
  isSagaRegistered: false,
  isLoggingIn: false,
  isAuthenticating: false,
  isLoggingOut: false,
  user: null,
  token: null,
  isAuthenticated: false,
  error: null,
  permissions: ["NO ACCESS", "READ", "DISPLAY", "WRITE", "ADMIN"],
  googleRef: null,
  isResetPassword: false,
  isSubmittingForgotPassword: false,
  isResetingPassword: false,
  isFetchingData: false,
  userData: {},
  subList: [],
  isSettingPassword: false,
  menuOpen: true,
  everyLocationHasFeed: false,
  // Email Unsubscribe
  isValidatingEmail: false,
  isEmailValidated: false,
  isEmailSubscribed: false,
  isUpdatingEmail: false,
  isGettingAppQR: false,
  appQR: null,
  menuIndicators: initialMenuIndicators,
};

/* eslint-disable default-case, no-param-reassign */
const AuthReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case REGISTER_SAGA:
        draft.isSagaRegistered = true;
        break;
      case LOGIN:
        draft.isLoggingIn = true;
        draft.error = null;
        break;
      case LOGIN_SUCCESS:
        draft.isAuthenticated = true;
        draft.isLoggingIn = false;
        draft.user = action.payload.user;
        draft.token = action.payload.token;
        draft.error = null;
        break;
      case LOGIN_FAILURE:
        draft.isLoggingIn = false;
        draft.error = action.error;
        break;
      case CHECK:
        draft.isAuthenticating = true;
        break;
      case CHECK_SUCCESS:
        draft.isAuthenticated = true;
        draft.isAuthenticating = false;
        draft.user = action.payload.user;
        draft.token = action.payload.token;
        break;
      case CHECK_FAILURE:
        return initialState;
      case UPDATE_USER:
        break;
      case UPDATE_USER_SUCCESS:
        draft.isAuthenticated = true;
        draft.user = action.payload.user;
        draft.token = action.payload.token;
        break;
      case UPDATE_USER_FAILURE:
        return initialState;

      case LOGOUT:
        draft.isLoggingOut = true;
        draft.error = null;
        break;
      case LOGOUT_SUCCESS:
        draft = initialState;
        break;
      case LOGOUT_FAILURE:
        draft.isLoggingOut = false;
        draft.error = action.error;
        break;
      case GOOGLE_INITIALIZED:
        draft.googleRef = action.payload;
        break;

      case SENT_RESET_PASSWORD_SUCCESS:
        draft.isResetPassword = false;
        break;
      case SENT_RESET_PASSWORD_FAILURE:
        draft.isResetPassword = false;
        break;
      case SENT_RESET_PASSWORD_PENDING:
        draft.isResetPassword = true;
        break;

      case FORGOT_PASSWORD:
        draft.isSubmittingForgotPassword = true;
        break;
      case FORGOT_PASSWORD_SUCCESS:
        draft.isSubmittingForgotPassword = false;
        break;
      case FORGOT_PASSWORD_FAILURE:
        draft.isSubmittingForgotPassword = false;
        break;

      case RESET_PASSWORD:
        draft.isResetingPassword = true;
        break;
      case RESET_PASSWORD_SUCCESS:
        draft.isResetingPassword = false;
        break;
      case RESET_PASSWORD_FAILURE:
        draft.isResetingPassword = false;
        break;

      case GET_USERDATA:
        draft.isFetchingData = true;
        draft.userData = {};
        break;
      case GET_USERDATA_SUCCESS:
        draft.isFetchingData = false;
        draft.userData = action.payload;
        break;
      case GET_USERDATA_FAILURE:
        draft.isFetchingData = false;
        draft.userData = {};
        break;

      case GET_SUBLIST:
        draft.subList = [];
        break;
      case GET_SUBLIST_SUCCESS:
        draft.subList = action.payload;
        break;
      case GET_SUBLIST_FAILURE:
        draft.subList = [];
        break;

      case SET_PASSWORD:
        draft.isSettingPassword = true;
        break;
      case SET_PASSWORD_SUCCESS:
        draft.isSettingPassword = false;
        break;
      case SET_PASSWORD_FAILURE:
        draft.isSettingPassword = false;
        break;
      case TOGGLE_MENU:
        draft.menuOpen = action.payload;
        break;
      case UPDATE_ALL_FEED_ACCESS:
        draft.everyLocationHasFeed = action.payload;
        break;

      case CHECK_EMAIL_SUB:
        draft.isValidatingEmail = true;
        draft.isEmailValidated = false;
        draft.isEmailSubscribed = null;
        break;
      case CHECK_EMAIL_SUB_SUCCESS:
        draft.isValidatingEmail = false;
        draft.isEmailValidated = true;
        draft.isEmailSubscribed = action.payload;
        break;
      case CHECK_EMAIL_SUB_FAILURE:
        draft.isValidatingEmail = false;
        draft.isEmailValidated = true;
        draft.isEmailSubscribed = null;
        break;

      case UPDATE_EMAIL_SUB:
        draft.isUpdatingEmail = true;
        break;
      case UPDATE_EMAIL_SUB_SUCCESS:
        draft.isUpdatingEmail = false;
        break;
      case UPDATE_EMAIL_SUB_FAILURE:
        draft.isUpdatingEmail = false;
        break;

      case GET_APP_QR:
        draft.isGettingAppQR = true;
        draft.appQR = null;
        break;
      case GET_APP_QR_SUCCESS:
        draft.isGettingAppQR = false;
        draft.appQR = action.payload;
        break;
      case GET_APP_QR_FAILURE:
        draft.isGettingAppQR = false;
        draft.appQR = null;
        break;

      case GET_MENU_INDICATORS:
        draft.menuIndicators = initialMenuIndicators;
        break;
      case GET_MENU_INDICATORS_SUCCESS:
        draft.menuIndicators = action.payload;
        break;
      case GET_MENU_INDICATORS_FAILURE:
        draft.menuIndicators = initialMenuIndicators;
        break;
      case TOKEN_REFRESHED:
        draft.token = action.payload;
        break;
      default:
        return state;
    }
  });

export default AuthReducer;
